export default class DeleteReferenciaEnlaceC3 {
  #repository
  constructor(repository) {
    this.#repository = repository
  }

  async execute(idPersonal, idReferencia) {
    return await this.#repository.delete(idPersonal, idReferencia)
  }
}
